<form [formGroup]="HeaderForm" (ngSubmit)="onSubmit()">
  <div class="content-top-row headForm" style="display: flex;">


    <mat-form-field appearence="fill" class="unit-pick">
      <input [readonly]="true" matInput formControlName="Unit" [(ngModel)]="HeaderData.UnitName"
        placeholder="{{langObj ? langObj?.Unit : (' Unit' | translate)}}" (click)="openModal()">
      <span matSuffix (click)="openModal()">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 9.375V5.625H4.6875V6.5625H2.8125V3.75H11.25V0H0V3.75H1.875V13.125H4.6875V15H15V11.25H4.6875V12.1875H2.8125V7.5H4.6875V9.375H15Z"
            fill="#824AED" />
        </svg>
      </span>
      <mat-error>{{langObj ? langObj?.UnitisRequired : (' UnitisRequired' | translate)}}</mat-error>
    </mat-form-field>

    <app-unit-picker [Group]="HeaderData.Group" (emitSelectedUnit)="setUnit($event)"
      [unitPickerIsOpen]="unitPickerIsOpen"></app-unit-picker>
    <nz-date-picker readonly [nzShowTime]="false" nzFormat="dd-MMM-yyyy" [(ngModel)]="HeaderData.Date"
      formControlName="Date" (ngModelChange)="onChange($event)"></nz-date-picker>
    <button *ngIf="isCreate | permissionChecker" type="submit" class="add-btn1" pTooltip="add" tooltipPosition="right">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
  </div>
</form>